import React from 'react';
import MuiLink from '@material-ui/core/Link';
import { GetApp } from '@material-ui/icons';

import { getIconDevice } from 'ui/icons/Device';
import SimpleTable from 'ui/Table';
import DateFormater from 'ui/formats/Date';

export default function DownloadTable({
    files,
    empty,
    account,
    company,
    downloadable,
}) {
    const options = {
        compact: true,
        columns: [
            {
                styles: { align: 'left' },
                format: value => <DateFormater value={value} />,
            },
            null,
            {
                format: value => getIconDevice(value),
            },
            {
                format: value =>
                    downloadable ? downloadLink(company, account, value) : '',
            },
        ],
        header: ['Created at (UTC)', 'Device name', 'Device type', ' '],
        empty,
    };

    const downloadLink = (company, account, file) => {
        const url = `/api/organization/${company}/backups/${account}/download/${file}`;
        return (
            <MuiLink color="secondary" underline="none" href={url}>
                <GetApp />
            </MuiLink>
        );
    };

    return <SimpleTable data={files} options={options} />;
}
